<script setup lang="ts">
import { ref } from "vue";
import type LxcError from "~/core/models/LxcError.class";
import { PATH_SUPER_ADMINISTRATION_SETTINGS_TRUSTSTORE } from "~/modules/superAdministration/constants";

const props = defineProps<{
  isTagsLoading: boolean;
  tagsError?: LxcError | null;
  tags?: string[] | null;
  showForm: boolean;
}>();

const emit = defineEmits(["update:showForm"]);

const truststoreListRef = ref();

function refreshTruststoreList() {
  truststoreListRef.value?.search();
}

const _showForm = computed({
  get() {
    return props.showForm;
  },
  set() {
    emit("update:showForm");
  },
});
</script>

<template>
  <truststore-list
    ref="truststoreListRef"
    :is-tags-loading="isTagsLoading"
    :tags-error="tagsError"
    :tags="tags"
    :path-context="PATH_SUPER_ADMINISTRATION_SETTINGS_TRUSTSTORE"
  />
  <truststore-upload-certificate
    v-model:side-canvas-shown="_showForm"
    :is-tags-loading="isTagsLoading"
    :tags-error="tagsError"
    :tags="tags"
    @save="refreshTruststoreList"
  />
</template>
